import React, { useState } from "react";
import { Pencil, Check, X } from "lucide-react";

const FORMAS = ["PIX", "Dinheiro", "Transferência", "Cheque", "Cartão", "Boleto", "Outro"];
const inp = { background: "#0d0d0f", border: "1px solid #2b2833", color: "#f5f0e8", padding: "4px 6px", fontSize: 12, borderRadius: 3, boxSizing: "border-box" };
const ico = { background: "transparent", border: "1px solid #2b2833", color: "#cdc8be", padding: "2px 6px", cursor: "pointer", borderRadius: 3, display: "inline-flex", alignItems: "center" };

export const BtnEditPagamento = ({ onClick, testid }) => (
  <button onClick={onClick} style={{ ...ico, marginRight: 6 }} title="Editar pagamento" data-testid={testid}><Pencil size={11} /></button>
);

/* Linha de edição de um pagamento parcial já registrado (data, valor, forma, observação). */
export function PagamentoEditRow({ p, onSave, onCancel }) {
  const [data, setData] = useState(p.data || "");
  const [valor, setValor] = useState(String(p.valor ?? ""));
  const [forma, setForma] = useState(p.forma_pagamento || "");
  const [obs, setObs] = useState(p.observacoes || "");
  const [salvando, setSalvando] = useState(false);
  const salvar = async () => {
    const v = Number(String(valor).replace(",", "."));
    if (!(v > 0)) return alert("Valor deve ser maior que zero.");
    if (!data) return alert("Informe a data.");
    setSalvando(true);
    try { await onSave({ data, valor: v, forma_pagamento: forma || null, observacoes: obs }); } finally { setSalvando(false); }
  };
  return (
    <tr style={{ borderTop: "1px solid #2b2833", background: "rgba(184,147,90,0.06)" }} data-testid={`pagamento-edit-${p.id}`}>
      <td style={{ padding: "6px 8px" }}><input type="date" value={data} onChange={e => setData(e.target.value)} style={inp} data-testid={`pag-edit-data-${p.id}`} /></td>
      <td style={{ padding: "6px 8px", textAlign: "right" }}><input type="number" step="0.01" value={valor} onChange={e => setValor(e.target.value)} style={{ ...inp, width: 100 }} data-testid={`pag-edit-valor-${p.id}`} /></td>
      <td style={{ padding: "6px 8px" }}>
        <select value={forma} onChange={e => setForma(e.target.value)} style={inp} data-testid={`pag-edit-forma-${p.id}`}>
          <option value="">—</option>
          {FORMAS.map(f => <option key={f} value={f}>{f}</option>)}
        </select>
      </td>
      <td style={{ padding: "6px 8px" }}><input value={obs} onChange={e => setObs(e.target.value)} style={{ ...inp, width: "100%" }} data-testid={`pag-edit-obs-${p.id}`} /></td>
      <td style={{ padding: "6px 8px" }} />
      <td style={{ padding: "6px 8px", textAlign: "right", whiteSpace: "nowrap" }}>
        <button onClick={salvar} disabled={salvando} style={{ ...ico, color: "#5fa86c", marginRight: 6 }} title="Salvar" data-testid={`pag-edit-salvar-${p.id}`}><Check size={12} /></button>
        <button onClick={onCancel} style={ico} title="Cancelar" data-testid={`pag-edit-cancelar-${p.id}`}><X size={12} /></button>
      </td>
    </tr>
  );
}
